import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import i18n from "./i18n"
import "vant/lib/index.css" // 注释掉全量CSS导入，改用按需导入
import "./styles/main.css"
import navBar from "./components/navBar.vue"
import CommonDialog from "./components/CommonDialog.vue"


import { Icon, Button, Popup, Empty, Field, Cell, Toast } from 'vant';

// 全局注册
Vue.use(Icon);
Vue.use(Button);
Vue.use(Popup);
Vue.use(Empty);
Vue.use(Field);
Vue.use(Cell);
Vue.use(Toast);

Vue.config.productionTip = false

Vue.component("navBar", navBar)
Vue.component("CommonDialog", CommonDialog)
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app")
